import { AxiosError } from 'axios';
import axiosClient from '../axiosClient';
import { useCustomMutation } from '../utils/useCustomMutation';
import { PUT_CANDIDATE_HISTORIES_START_PROCESSING_URL } from '../../constants/apiUrls';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================

export interface FileProcessingRequest {
  uuid: string;
  examTypeUuid?: string;
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (res: void) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const usePutStartCandidateHistoriesProcessing = ({ onSuccess, onError }: Input) => {
  const putStartCandidateHistoriesProcessing = async (payload: FileProcessingRequest) => {
    await axiosClient.put<undefined>(PUT_CANDIDATE_HISTORIES_START_PROCESSING_URL, payload);
  };
  return useCustomMutation(putStartCandidateHistoriesProcessing, {
    onSuccess,
    onError,
  });
};
